import { blueGrey, grey, lightBlue, orange, red, teal } from '@mui/material/colors';
import { experimental_extendTheme as extendTheme } from '@mui/material/styles';
import { appBarThemeDefinition, buttonThemeDefinition, tooltipThemeDefinition } from './components';
import { tabsThemeDefinition } from './components/tabsThemeDefinition';
const fontFamily = "'Roboto', 'Helvetica', 'Arial', sans-serif";
const themeExtended = extendTheme({
    typography: { fontFamily: fontFamily },
    colorSchemes: {
        light: {
            palette: {
                primary: {
                    light: teal['200'],
                    main: teal['500'],
                    dark: teal['900'],
                },
                secondary: {
                    light: lightBlue['200'],
                    main: lightBlue['700'],
                    dark: lightBlue['900'],
                },
                error: {
                    light: red['500'],
                    main: '#d32f2f',
                    dark: red['700'],
                },
                modifyGrey: {
                    light: grey['200'],
                    main: grey['400'],
                    dark: grey['600'],
                    contrastText: grey['800'],
                },
                warning: {
                    main: orange['400'],
                },
                text: {
                    primary: blueGrey['800'],
                    secondary: blueGrey['500'],
                },
                border: {
                    light: '#EEEEEE',
                    main: blueGrey['100'],
                },
                common: {
                    white: '#FFFFFF',
                    black: '#37474f',
                },
            },
        },
    },
    components: {
        ...appBarThemeDefinition(),
        ...buttonThemeDefinition(),
        ...tabsThemeDefinition(),
        ...tooltipThemeDefinition(),
    },
});
export const theme = themeExtended;
//# sourceMappingURL=theme.js.map